import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

/** ----------------------------------------------------------------------------
 * REQUEST A PASSWORD RESET
 -----------------------------------------------------------------------------*/

export const requestPasswordResetRequested = () => ({
  type: SettingsActionTypes.REQUEST_PASSWORD_RESET_REQUESTED,
  isRequesting: true,
});

export const requestPasswordResetSuccess = response => ({
  type: SettingsActionTypes.REQUEST_PASSWORD_RESET_SUCCESS,
  isRequesting: false,
  isSuccess: response.isSuccess,
  message: response.message,
});

export const requestPasswordResetFailure = error => ({
  type: SettingsActionTypes.REQUEST_PASSWORD_RESET_FAILURE,
  isRequesting: false,
  error: true,
  status: error.response && error.response.status,
});

export default requestPasswordReset(new SettingsService());

export function requestPasswordReset(service) {
  return emailAddress => (dispatch) => {
    dispatch(requestPasswordResetRequested());

    service.requestPasswordReset(emailAddress).then(
      response => dispatch(requestPasswordResetSuccess(response.data)),
      error => dispatch(requestPasswordResetFailure(error)),
    );
  };
}